import { Grid } from "@mui/material";
import { useEffect, useReducer } from "react"
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next"
import CustomAlert from "../../componentes/alerts/CustomAlert"
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import InputField from "../../componentes/form-fields/InputField/InputField";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer"
import SupplierControlService from "./SupplierControlService"
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import DefaultChip from "../../componentes/chip/DefaultChip";
import { Typography } from "@material-ui/core";

/**
 * Author : AndréK
 * 26/08/2022
*/
const columnsSupplier = (t) => [
    { field: "id", flex: 0.5, visible: false },
    {
        field: "supplierName",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="supplierName" name="company"/>;
        },
        template: (props) => {
            return (
                <>
                    {props.cnpj ?
                        <DefaultChip
                            style="grey"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.supplierName}
                            </Typography>}
                        />
                    : null}
                </>
            )
        }
        
    },
    {
        field: "socialReason",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="socialReason" name="company"/>;
        },
        flex: 1
    },
    {
        field: "cnpj",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="cnpj" name="cnpj"/>;
        },
        flex: 1,
        template: (props) => {
            return (
                <>
                    {props.cnpj ?
                        <DefaultChip
                            style="standard"
                            label={<Typography
                                variant="body3"
                                style={{ whiteSpace: 'normal' }}>{props.cnpj}
                            </Typography>}
                        />
                    : null}
                </>
            )
        }
    },
    {
        field: "status",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="status" />;
        },
        flex: 0.5,
        template: (props) => {
            return (
                <>
                    {props.status ? (
                        <IconSwitch name="active" />
                    ) : (
                        <IconSwitch name="canceled" />
                    )}
                </>
            );
        },
    },
];

export const SupplierRegister = ({ updateId }) => {

    const { t } = useTranslation();
    const { control } = useForm();
    const userId = sessionStorage.getItem("userId");

    const initialState = {
        id: 0,
        supplierName: "",
        socialReason: "",
        cnpj: "",
        SupplierRows: [],
        img: "",
        loggedUserId: userId,
        status: 1,
        success: false,
        error: false,
    };

    function formatCNPJ(value) {
        value = value.replace(/\D/g, '');

        value = value.replace(/^(\d{2})(\d)/, '$1.$2');
        value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
        value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');
        value = value.replace(/(\d{4})(\d)/, '$1-$2');

        return value.slice(0, 18); // Limita ao tamanho máximo do CNPJ
    }

    const reducer = (state, action) => {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case "clear":
                return initialState
            case 'success':
                return { ...state, success: true, error: false }
            case 'error':
                return { ...state, success: false, error: true }
            case 'close_alert':
                return { ...state, success: false, error: false }
            default:
                return new Error();
        }
    }

    const [SupplierControl, dispatch] = useReducer(reducer, initialState);

    const { id, supplierName, socialReason, cnpj, status, img } = SupplierControl
    const { success, error, SupplierRows, ...data } = SupplierControl

    useEffect(() => {
        updateId({ id: id })
    }, [id])

    const handleChange = ({ target: { name, value } }) => {
        if (name === 'cnpj')
        {
            const formatted = formatCNPJ(value);
            dispatch({ type: 'update', data: { [name]: value, cnpj: formatted } })
        }
        else{
            dispatch({ type: 'update', data: { [name]: value } })
        }
    }

    const handleSearch = () => {
        SupplierControlService
            .getSupplier(data)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({ type: 'update', data: { SupplierRows: response.data } })
                }
            })
            .catch((e) => dispatch({ type: 'update', data: { SupplierRows: [] } }));
    }
    const canSave = () => supplierName !== "" && cnpj !== "" && status !== 2;

    const handleSaveUpdate = () => {
        if (canSave()) {
            if (id) {
                SupplierControlService
                    .updateSupplier(data)
                    .then((response) => {
                        if (response.status === 200) {
                            dispatch({ type: 'success' })
                            handleSearch();
                        }
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            }
            else {
                SupplierControlService
                    .createSupplier(data)
                    .then((response) => {
                        if (response.status === 200) {
                            dispatch({type: 'update', data: {success: true, error: false, id: response.data.id, message: t("noDataExport") } })
                            handleSearch();
                        }
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            }
        } else {
            dispatch({ type: 'error' })
        }

    }

    const handleCellClickSupplier = (data) => {
        dispatch({
            type: 'update', data: {
                id: data.id,
                supplierName: data.supplierName,
                socialReason: data.socialReason,
                cnpj: data.cnpj,
                status: data.status,
                img: data.img,
            }
        })
    }

    const handleReloadImg = () => {
        SupplierControlService
            .getSupplier(data)
            .then((response) => {
                if (response.status === 200) {
                    const rows = []
                    response.data.forEach(item => {
                        rows.push({
                            id: item.id,
                            supplierName: item.supplierName,
                            socialReason: item.socialReason,
                            cnpj: item.cnpj,
                            img: item.img,
                            status: item.status
                        });
                    });
                    dispatch({ type: 'update', data: { ...rows[0], SupplierRows: rows } })
                }
            })
            .catch((e) => dispatch({ type: 'update', data: { SupplierRows: [] } }));
    }

    useEffect(() => {
        handleSearch();
    }, [])

    return (
        <>
            <DefaultScreenAccordion
                isTab
                fields={
                    <GridItemContainer>
                        <CustomAlert
                            success={success}
                            error={error}
                            handleCloseAlert={() => dispatch({ type: 'close_alert' })}
                        />
                        <Grid item xs={id !== 0 ? 7 : 12} sm={id !== 0 ? 8 : 12} md={id !== 0 ? 10 : 12}>
                            <GridInputRow>
                                <Grid item xs={12} sm={6} md={4}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="company" labelName="supplierName" />
                                        }
                                        name="supplierName"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={supplierName}
                                        inputProps={{ maxLength: 50 }}
                                        error={error && supplierName === ""}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="company" labelName="socialReason" />
                                        }
                                        name="socialReason"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={socialReason}
                                        inputProps={{ maxLength: 150 }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="cnpj" labelName="cnpj" />
                                        }
                                        name="cnpj"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={cnpj}
                                        inputProps={{maxLength: 18}}
                                        error={error && cnpj === ""}
                                    />
                                </Grid>
                                <GridInputRow>
                                </GridInputRow>
                                <Grid item xs={12} sm={6} md={4}>
                                    <DefaultAutocomplete
                                        name={"status"}
                                        onChange={handleChange}
                                        value={status}
                                        label={t("status")}
                                        defaultSize
                                        items={[
                                            { id: 0, name: t("canceled"), status: 1 },
                                            { id: 1, name: t("active"), status: 1 },
                                            { id: 2, name: t("all"), status: 1 },
                                        ]}
                                        error={error && status === 2}
                                    />
                                </Grid>
                            </GridInputRow>
                        </Grid>

                        <SearchClearSaveRow
                            onClickSearch={handleSearch}
                            onClickClear={() => dispatch({ type: 'clear' })}
                            onClickSave={handleSaveUpdate}
                        />
                        {(SupplierRows.length > 0) ? (
                            <GridInputRow>
                                <Grid item xs={12}>
                                    <DefaultDatagrid
                                        columns={columnsSupplier(t)}
                                        dataSource={SupplierRows}
                                        allowPaging={true}
                                        cellSelected={(args, grid) =>
                                            handleCellClickSupplier(args.data)
                                        } />
                                </Grid>
                            </GridInputRow>
                        ) : null}
                    </GridItemContainer>
                } />
        </>
    );
}